import { writable } from "svelte/store";
import type { Writable } from "svelte/store";
import type { PageCondition } from "./types";

export const loadedFiles: Writable<(string | ArrayBuffer)[]> = writable([])




export function storable(data: PageCondition, name: string) {
    const store = writable(data);
    const { subscribe, set, update } = store;
    const isBrowser = typeof window !== 'undefined';
    const strageName = name

    isBrowser && sessionStorage.getItem(strageName) && set(JSON.parse(sessionStorage.getItem(strageName)));

    return {
        subscribe,
        set: n => {
            // console.log(sessionStorage.getItem(name));
            isBrowser && (sessionStorage.setItem(strageName, JSON.stringify(n)));
            // console.log('set', n, strageName);
            set(n);
        },
    };
}
